import store from '@/store';


function routerBeforeEnterAppDownloadPage(to, from, next) {
  const merchant = store.getters['merchant/merchant'];

  const isLandingPageEnabled = merchant.features['enable-gift-claim-app-download-landing-page'];

  const isAppDownloadEnabled = merchant.features.aosUrl || merchant.features.iosUrl;

  const menuReroute = {
    name: 'order',
    params: {
      merchantId: to.params.merchantId
    }
  };

  return isLandingPageEnabled && isAppDownloadEnabled
    ? next()
    : next(menuReroute);
}

export default routerBeforeEnterAppDownloadPage;
